<template>
    <Card :title="$t('cardTitles.settings')">
        <div class="card-body">
            <FieldSet :title="$t('labels.import')">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="alert alert-primary border-0 alert-dismissible">
                            <button type="button" class="close" data-dismiss="alert"><span>×</span></button>
                            <span class="font-weight-semibold mr-1">{{ $t('alerts.orders_import_requirements_title') }}</span>
                            {{ $t('alerts.orders_import_requirements_desc') }}
                            <ul class="list mb-0 mt-2 pl-4">
                                <li>
                                    <span v-if="integration.api_credentials?.is_active"><del>{{ $t('alerts.orders_import_requirements_api') }}</del></span>
                                    <span v-else>{{ $t('alerts.orders_import_requirements_api') }}</span>
                                </li>

                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <FormGroup :label="$t('labels.enable')">
                            <InputGroup>
                                <template #prepend>
                                    <CheckBox :disabled="!integration.api_credentials?.is_active" v-model="turnOnImportOrders"/>
                                </template>
                            </InputGroup>
                        </FormGroup>
                    </div>
                    <div class="col-lg-4">
                        <FormGroup :label="$t('labels.date_enabled')">
                            <div v-if="integration?.order_settings">
                                {{ DateFormatter.formatDateTime(integration.order_settings?.turn_on_at) ?? $t('labels.not_enables') }}
                            </div>
                            <u class="text-muted d-block" v-else>{{ $t('labels.empty') }}</u>
                        </FormGroup>
                    </div>
                    <div class="col-lg-4">
                        <FormGroup :label="$t('labels.date_of_last_import')">
                            <div v-if="integration?.order_settings">{{ DateFormatter.formatDateTime(integration.order_settings?.last_import_at) ?? $t('labels.not_imported') }}</div>
                            <u class="text-muted d-block" v-else>{{ $t('labels.empty') }}</u>
                        </FormGroup>
                    </div>
                </div>
            </FieldSet>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <Button size="sm" @click="save" color="indigo">{{ $t('buttons.save') }}</Button>
        </div>
    </Card>
</template>
<script>
import Card from '../../../../../js/components/new/CardComponent.vue';
import FormGroup from '../../../../../js/components/new/form/group/FormGroup.vue';
import Button from '../../../../../js/components/new/button/AppButton.vue';
import FieldSet from '../../../../../js/components/new/AppFieldset.vue';
import CheckBox from '../../../../../js/components/new/form/checkbox/AppCheckbox.vue';
import InputGroup from '../../../../../js/components/new/form/InputGroup.vue';
import DateFormatter from "../../../../services/DateFormatter"

import { httpClient } from '../../../../../js/services/HttpClient';
import MessageNotificator from '../../../../services/MessageNotificator';

export default {
    name: "OrdersCard",
    components: {
        Card, FormGroup, Button, FieldSet, CheckBox, InputGroup
    },
    props: {
        integration: {
            type: Object,
            required: true
        }
    },
    emits: ['update:integration'],
    data() {
        return {
            DateFormatter,
            turnOnImportOrders: Boolean(this.integration?.order_settings?.turn_on_at) ?? false,
        }
    },
    methods: {
        save() {
            let request = {};

            if (this.turnOnImportOrders !== this.ordersSettings?.turn_on_at) {
                request.order_settings ? request.order_settings.turn_on = this.turnOnImportOrders : request.order_settings = {turn_on: this.turnOnImportOrders};
            }

            this.$emit('update:integration', request)
        },
    }
}
</script>